import isNil from 'lodash/isNil'
import pickBy from 'lodash/pickBy'

import type { Bounds } from './Bounds'
import type { Point } from './Point'

export type Address = {
  label?: string
  kind?: string
  location: Point
  bounds?: Bounds
  /** Set only for a pin saved without an address, which no suggestion can claim to be. */
  isPoint?: boolean
}

export function createAddress(address: Address): Address {
  return pickBy(address, v => !isNil(v)) as Address
}
